import { useMemo } from "react";
import { motion } from "framer-motion";

// Lightweight CSS/framer particle field (no external deps)
export default function Particles({ count = 26 }) {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 3 + 1,
        dur: Math.random() * 6 + 6,
        delay: Math.random() * 5,
        blue: Math.random() > 0.4,
      })),
    [count]
  );

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {dots.map((d) => (
        <motion.span
          key={d.id}
          className="absolute rounded-full"
          style={{
            left: `${d.x}%`,
            top: `${d.y}%`,
            width: d.size,
            height: d.size,
            background: d.blue ? "#2563eb" : "rgba(255,255,255,0.7)",
            boxShadow: d.blue ? "0 0 8px #2563eb" : "0 0 6px rgba(255,255,255,0.6)",
          }}
          animate={{ y: [0, -30, 0], opacity: [0.2, 0.9, 0.2] }}
          transition={{ duration: d.dur, delay: d.delay, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}
